import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { PageMixin } from '../_internal/PageMixin';
import From from "./FromTs";


@Component
export default class PaymentCreate extends PageMixin {

    public type: string = "journal";
    public title: string = 'Recent Journal';
    public editName: string = 'Transaction.journal.edit';

    render(h: CreateElement) {

        return this.renderCollection(h, h(From, {
            props: {
                type: this.type,
                id: this.id,
            },
            on: {
                push: this.push
            }
        }))

    }
}